(function () {
  function pauseMedia(container) {
    if (!container) return;

    container.querySelectorAll('video').forEach(function (video) {
      if (typeof video.pause === 'function') video.pause();
    });

    container.querySelectorAll('iframe').forEach(function (iframe) {
      var src = iframe.getAttribute('src');
      if (src) iframe.setAttribute('src', src);
    });
  }

  function activateMedia(gallery, thumb) {
    if (!gallery || !thumb) return;

    var mediaId = thumb.getAttribute('data-media-id');
    var matchedMedia = mediaId ? gallery.querySelector('[data-product-gallery-media="' + mediaId + '"]') : null;

    if (matchedMedia) {
      gallery.querySelectorAll('[data-product-gallery-media]').forEach(function (media) {
        var isActive = media === matchedMedia;
        media.classList.toggle('is-active', isActive);
        media.hidden = !isActive;

        if (!isActive) pauseMedia(media);
      });
    } else {
      var mainImage = gallery.querySelector('.product-gallery__main-media.is-active .product-gallery__main-image') || gallery.querySelector('.product-gallery__main-image');
      var fullSrc = thumb.getAttribute('data-full-src');
      var fullSrcset = thumb.getAttribute('data-full-srcset');
      var alt = thumb.getAttribute('data-alt') || '';

      if (mainImage) {
        if (fullSrc) mainImage.src = fullSrc;
        if (fullSrcset) mainImage.srcset = fullSrcset;
        mainImage.alt = alt;
      }
    }

    gallery.querySelectorAll('[data-product-gallery-thumb]').forEach(function (item) {
      var isActive = item === thumb;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-product-gallery-thumb]');
    if (!thumb) return;

    var gallery = thumb.closest('[data-product-gallery]');
    if (!gallery) return;

    activateMedia(gallery, thumb);
  });
})();
